import { Store } from 'src/store/index';
import hasEmbroideryWarnings from './hasEmbroideryWarnings';

const getCanDesignBeSaved = (store: Store) => store.design.errors.length === 0 && !hasEmbroideryWarnings(store.design.structure);

export default getCanDesignBeSaved;
